
import React from "react";
import { NursingHomeCard } from "@/components/nursing-homes/NursingHomeCard";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronUp, ChevronDown } from "lucide-react";

interface CountyCollapsibleSectionProps {
  county: string;
  homes: any[];
  isExpanded: boolean;
  toggleCountyExpansion: (county: string) => void;
}

export function CountyCollapsibleSection({
  county,
  homes,
  isExpanded,
  toggleCountyExpansion
}: CountyCollapsibleSectionProps) {
  return (
    <Collapsible 
      key={county} 
      open={isExpanded}
      onOpenChange={() => toggleCountyExpansion(county)}
      className="border border-gray-200 rounded-lg overflow-hidden mb-6"
    >
      <CollapsibleTrigger className="w-full">
        <div className="bg-grandpal-beige px-6 py-4 flex justify-between items-center">
          <div>
            <h2 className="text-xl font-semibold">{county}</h2>
            <p className="text-sm text-grandpal-gray">{homes.length} nursing homes</p>
          </div>
          {isExpanded ? 
            <ChevronUp className="h-5 w-5 text-grandpal-green" /> : 
            <ChevronDown className="h-5 w-5 text-grandpal-green" />
          }
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {homes.map((home) => (
              <div key={home.nh_slug} className="flex">
                <NursingHomeCard 
                  nursingHome={home}
                  hideBorder={false}
                  size="md"
                />
              </div>
            ))}
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
